import { createContext, useContext, useState } from 'react';
import { DEFAULT_PREFS } from '../projects/dnd/dmView/constants';

// Create a Context
const UserContext = createContext();

// Custom hook to use the UserContext
export const useUser = () => {
    return useContext(UserContext);
};


// Provider component
export const UserProvider = ({ children }) => {
    const [username, setUsername] = useState('Username');
    const [password, setPassword] = useState('');
    const [sessionID, setSessionID] = useState(null);
    const [spotifyInfo, setSpotifyInfo] = useState(null);
    const [prefs, setPrefs] = useState(DEFAULT_PREFS);

    return (
        <UserContext.Provider 
            value={{ username, setUsername,
                password, setPassword,
                sessionID, setSessionID,
                spotifyInfo, setSpotifyInfo,
                prefs, setPrefs 
            }}
        >
            {children}
        </UserContext.Provider>
    );
};